import React from "react";
import {
    CURRENT_MONTH,
    CURRENT_WEEK,
    DATE_DAY,
    DATE_HOUR,
    DATE_MONTH,
    DATE_WEEK,
    LAST_14_DAYS,
    LAST_14_5_DAYS,
    LAST_17_2_DAYS,
    LAST_2_DAYS,
    LAST_30_DAYS,
    LAST_30_5_DAYS,
    LAST_7_DAYS,
    LAST_MONTH,
    LAST_WEEK,
    TODAY,
    YESTERDAY
} from "./constants";

export const fromDate = (period) => {
    let currentDate = deductTimezoneOffset(new Date());
    let day;
    switch (period) {
        case (TODAY):
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (YESTERDAY):
        case (LAST_2_DAYS):
            currentDate.setDate(currentDate.getDate() - 1);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_7_DAYS):
            currentDate.setDate(currentDate.getDate() - 6);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_14_DAYS):
            currentDate.setDate(currentDate.getDate() - 13);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_14_5_DAYS):
            currentDate.setDate(currentDate.getDate() - 13 - 5);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_17_2_DAYS):
            currentDate.setDate(currentDate.getDate() - 16 - 2);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_30_DAYS):
            currentDate.setDate(currentDate.getDate() - 30);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_30_5_DAYS):
            currentDate.setDate(currentDate.getDate() - 30 - 5);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (CURRENT_WEEK):
            day = currentDate.getDate() - currentDate.getDay();
            currentDate = new Date(currentDate.setDate(day));
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_WEEK):
            day = currentDate.getDate() - currentDate.getDay() - 6;
            currentDate = new Date(currentDate.setDate(day));
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (CURRENT_MONTH):
            return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        case (LAST_MONTH):
            return new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        default:
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
    }
};


export const toDate = (period) => {
    let currentDate = deductTimezoneOffset(new Date());
    let day;
    switch (period) {
        case (TODAY):
        case (LAST_2_DAYS):
        case (LAST_7_DAYS):
        case (LAST_14_DAYS):
        case (LAST_30_DAYS):
            return currentDate;
        case (LAST_14_5_DAYS):
        case (LAST_30_5_DAYS):
            currentDate.setDate(currentDate.getDate() - 5);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_17_2_DAYS):
            currentDate.setDate(currentDate.getDate() - 2);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (YESTERDAY):
            currentDate.setDate(currentDate.getDate() - 1);
            // currentDate.setHours(23, 59, 59, 0);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (CURRENT_WEEK):
            // currentDate.setHours(23, 59, 59, 0);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_WEEK):
            day = currentDate.getDate() - currentDate.getDay() + 7;
            currentDate = new Date(currentDate.setDate(day));
            // currentDate.setHours(23, 59, 59, 0);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (CURRENT_MONTH):
            // currentDate.setHours(23, 59, 59, 0);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        case (LAST_MONTH):
            currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
            // currentDate.setHours(23, 59, 59, 0);
            currentDate.setHours(0, 0, 0, 0);
            return currentDate;
        default:
            return currentDate;
    }
};

export function isDateGroupType(groupType) {
        return groupType === DATE_HOUR
            || groupType === DATE_DAY
            || groupType === DATE_WEEK
            || groupType === DATE_MONTH;
}

export function isDateGroupData(groupData) {
    return groupData?.from || groupData?.to;
}

export const isSameDay = (date1, date2) => {
    return date1?.getDay() === date2?.getDay();
};

export const periodsInDays = (date1, date2) => {
    const differenceInMs = date1 - date2;
    return !differenceInMs
        ? 0
        : parseInt(differenceInMs / (1000 * 24 * 60 * 60));
};

export const getIsoLocalString = (date) => {
    return date ? new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10) : "";
};

/**Метод добавляет разницу между часовыми поясами сервера и браузера.
 * Например, таймзона сервера - Москва (GMT+0300), таймзона браузера - Новосибирск (GMT+0700)
 * Метод добавляем к исходной дате 4ч.
 * Пример: Вся статистика у нас отображается в часовом поясе сервера (МСК) независимо от местонахождения пользователя.
 * Поэтому в запросе к бэку неоходимо к дате, выбранной в датапикере, нужно добавить разницу между часовыми поясами.
 */
export const addTimezoneOffset = (date) => {
    const clonedDate = new Date(date.getTime());
    const timezonesDifference = (process.env.REACT_APP_SERVER_TIMEZONE_OFFSET - clonedDate.getTimezoneOffset()) / 60;
    return new Date(clonedDate.setHours(clonedDate.getHours() + timezonesDifference));
};

/**Метод убирает разницу между часовыми поясами сервера и браузера.
 * Например, таймзона сервера - Москва (GMT+0300), таймзона браузера - Новосибирск (GMT+0700)
 * Метод отнимает от исходной даты 4ч.
 * Пример: необходимо выгрузить статистику в xlsx и в названии файла указать текущее время выгрузки по МСК.
 */
export const deductTimezoneOffset = (date) => {
    const clonedDate = new Date(date.getTime());
    const timezonesDifference = (process.env.REACT_APP_SERVER_TIMEZONE_OFFSET - clonedDate.getTimezoneOffset()) / 60;
    return new Date(clonedDate.setHours(clonedDate.getHours() - timezonesDifference));
};



export const getServerCurrentDay = () => {
    const currentDate = deductTimezoneOffset(new Date());
    currentDate.setHours(0, 0, 0, 0);
    return currentDate;
};

export const getRusDateString = (date, yearDigits) => {
    const yearDig = yearDigits ? yearDigits : 4;
        return date
        ? ('0' + date.getDate()).slice(-2)
        + "."
        + ('0' + (date.getMonth() + 1)).slice(-2)
        + "." + date.getFullYear().toString().substr(-yearDig)
        : "";
};

export const getRusDateHourString = (date, yearDigits) => {
    const yearDig = yearDigits ? yearDigits : 4;
    return date
        ? ('0' + date.getDate()).slice(-2)
        + "."
        + ('0' + (date.getMonth() + 1)).slice(-2)
        + "." + date.getFullYear().toString().substr(-yearDig)
        + " "
        + ('0' + date.getHours()).slice(-2)
        + ":"
        + ('0' + date.getMinutes()).slice(-2)
        : "";
};

export const getRusHourDateString = (date) => {
    return date
        ?
        ('0' + date.getHours()).slice(-2)
        + ":"
        + ('0' + date.getMinutes()).slice(-2)
        + " "
        + ('0' + date.getDate()).slice(-2)
        + "."
        + ('0' + (date.getMonth() + 1)).slice(-2)
        + "." + date.getFullYear().toString().substr(-4)
        : "";
};

export const getMaxDate = (datesArr) => {
    if (!datesArr || datesArr.length === 0) {
        return null;
    }
    if (datesArr.length === 1) {
        return datesArr[0];
    }
    return datesArr.reduce((prev, curr) => prev > curr ? prev : curr);
};

export const DATE_RANGE_PATTERN = /([0]?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[012])\.([1-2][0-9])([\s][-\w][\s])([0]?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[012])\.([1-2][0-9])/;
export const DATE_PATTERN = /([0]?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[012])\.([1-2][0-9])/;

export const getDifferenceBetweenInDays = (date1, date2) => {
    const differenceInMs = Math.abs(date1 - date2);
    return !differenceInMs
        ? 0
        : differenceInMs / (1000 * 24 * 60 * 60);
}




